// Página que se muestra cuando el usuario intenta acceder a una sección sin permisos.
// Muestra botones para volver al login o al dashboard según el estado de sesión.

// frontend/src/components/UnauthorizedPage.js

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleNavigation = () => {
    if (user) {
      navigate('/dashboard'); // Si está autenticado, ir al dashboard
    } else {
      navigate('/login'); // Si no está autenticado, ir al login
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Acceso No Autorizado
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            No tienes permisos para acceder a esta página
          </p>
        </div>
        <div className="flex flex-col items-center space-y-4">
          <button
            onClick={handleNavigation}
            className="w-48 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-custom-brand hover:bg-custom-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-brand transition-colors duration-200"
          >
            {user ? 'Ir al Dashboard' : 'Ir al Login'}
          </button>
          
          {user && (
            <button
              onClick={() => navigate(-1)}
              className="w-48 flex justify-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-brand transition-colors duration-200"
            >
              Volver Atrás
            </button>
          )}
        </div>
        
        {user && (
          <div className="mt-4 text-center text-sm text-gray-500">
            <p>Usuario actual: {user.email}</p>
            <p className="mt-1">Si crees que esto es un error, contacta al administrador.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnauthorizedPage;